<script setup lang="ts">

import BaseContainer from "@/core/components/base/BaseContainer.vue";
import useSwr from "@/core/composables/swr/useSwr";
import {attachmentApi} from "@/container";
import BaseFlexSpinner from "@/core/components/base/spinner/BaseFlexSpinner.vue";
import AttachmentGrid from "@/attachment/components/AttachmentGrid.vue";
import BaseCard from "@/core/components/base/BaseCard.vue";
import BaseCardBody from "@/core/components/base/BaseCardBody.vue";
import HeaderBackButton from "@/core/components/header-back-button/HeaderBackButton.vue";
import {computed} from "vue";
import {storeToRefs} from "pinia";
import {useSystemStore} from "@/stores/system.store";

const {data, isLoading} = useSwr(
    "attachments?tags=patient-onboarding",
    () => attachmentApi().index({
        tags: ["patient-onboarding"],
    })
);

const {environment} = storeToRefs(useSystemStore());

/**
 * The attachment whose attachable_type is grouping.
 */
const groupingAttachments = computed(() => {
    if (!data.value) {
        return [];
    }

    return data.value.filter((attachment) => {
        return attachment.attachable_type === 'grouping';
    });
});

/**
 * The other attachments.
 */
const otherAttachments = computed(() => {
    if (!data.value) {
        return [];
    }

    return data.value.filter((attachment) => {
        return attachment.attachable_type !== 'grouping';
    });
});
</script>

<template>
  <BaseContainer>
    <HeaderBackButton title="Ressources de diffusion" />
    <BaseFlexSpinner v-if="isLoading" />
    <div v-else class="p-6 space-y-4">
      <BaseCard v-if="groupingAttachments.length">
        <BaseCardBody>
          <div class="flex">
            <h1 class="flex-1">
              De la part de votre groupement !
            </h1>
            <div v-if="environment?.entity.grouping?.branding?.logo?.renderPath" class="float-right">
              <img
                :src="environment.entity.grouping.branding.logo.renderPath"
                alt="grouping-logo"
                class="w-32"
              >
            </div>
          </div>
          <AttachmentGrid :attachments="groupingAttachments" />
        </BaseCardBody>
      </BaseCard>
      <BaseCard>
        <BaseCardBody>
          <AttachmentGrid v-if="otherAttachments.length" :attachments="otherAttachments" />
          <div v-else class="text-center text-gray-500">
            <p>Aucun document à afficher</p>
          </div>
        </BaseCardBody>
      </BaseCard>
    </div>
  </BaseContainer>
</template>

<style scoped>

</style>
